import { z } from 'zod';
import { BehoerdenvorgangKind, BehoerdenvorgangPhase } from '../enums.js';
import { isoDateString } from './project.js';
export const behoerdenVorgang = z.object({
    id: z.number().int().positive(),
    projectId: z.number().int().positive(),
    aktenzeichen: z.string().nullable().optional(),
    behoerde: z.string().nullable().optional(),
    kind: BehoerdenvorgangKind,
    phase: BehoerdenvorgangPhase,
    title: z.string(),
    description: z.string().nullable().optional(),
    prueferId: z.number().int().positive().nullable().optional(),
    // User-gepflegte Datums-Felder: akzeptieren 'JJJJ-MM-TT' (Date-Input) UND
    // volle ISO-Zeitstempel (Server) — das API konvertiert via `new Date()`.
    eingangsdatum: isoDateString.nullable().optional(),
    fristbis: isoDateString.nullable().optional(),
    erledigtAm: isoDateString.nullable().optional(),
    documentId: z.number().int().positive().nullable().optional(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
export const createBehoerdenVorgangRequest = behoerdenVorgang
    .omit({
    id: true,
    projectId: true,
    createdAt: true,
    updatedAt: true,
})
    .extend({
    title: z.string().min(1),
});
export const updateBehoerdenVorgangRequest = createBehoerdenVorgangRequest.partial();
/**
 * Ein Schriftstück im Verkehr mit der Behörde — in beide Richtungen.
 *
 * Bis hierher endete jeder Vorgang bei der eigenen Einreichung: Die Antwort der
 * Behörde landete im Postfach des Bearbeiters und tauchte im System nie auf.
 * Damit fehlte genau der Teil, der den Vorgang erst prüffähig macht.
 */
export const korrespondenzEintrag = z.object({
    id: z.number().int().positive(),
    vorgangId: z.number().int().positive(),
    /** true = von uns an die Behörde, false = bei uns eingegangen. */
    ausgehend: z.boolean(),
    /** Absender bzw. Empfänger. */
    source: z.string().nullable(),
    receivedAt: z.string().datetime(),
    receivedByName: z.string().nullable(),
    filename: z.string().nullable(),
    content: z.string().nullable(),
});
/**
 * Antwort von Hand erfassen. Notwendig, weil längst nicht jedes Büro ein
 * IMAP-Konto angebunden hat — ohne diesen Weg bliebe der Rückkanal für die
 * meisten Anwender theoretisch.
 */
export const createKorrespondenzRequest = z
    .object({
    ausgehend: z.boolean().default(false),
    /** Absender (eingehend) bzw. Empfänger (ausgehend). */
    source: z.string().min(1).max(200),
    /** Datum des Schriftstücks; ohne Angabe gilt „jetzt". */
    receivedAt: isoDateString.optional(),
    content: z.string().min(1).max(20000),
    filename: z.string().max(255).optional(),
})
    .strict();
